import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AttributeDetail from './components/AttributeDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageAttribute',
  components: {
    AttributeDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;